/**
 * @generated SignedSource<<662cb69c38d7d9eb20e64b514bde7e8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentTitleWithByLine_content$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content" | "ByLine_content" | "ContentTitle_content" | "MeetingNotesAutomationDiscoveryFragment_content">;
  readonly " $fragmentType": "ContentTitleWithByLine_content";
};
export type ContentTitleWithByLine_content$key = {
  readonly " $data"?: ContentTitleWithByLine_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "useNewContentTopper",
  "variableName": "useNewContentTopper"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeConnectionAncestors"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "useNewContentTopper"
    }
  ],
  "kind": "Fragment",
  "name": "ContentTitleWithByLine_content",
  "selections": [
    {
      "args": [
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "ContentTitle_content"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeConnectionAncestors",
          "variableName": "includeConnectionAncestors"
        },
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "ByLine_content"
    },
    {
      "kind": "FragmentSpread",
      "name": "ArchivedPageBannerV2Status_content"
    },
    {
      "kind": "FragmentSpread",
      "name": "MeetingNotesAutomationDiscoveryFragment_content"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "91555ecdfbb0de4b8c123665e7056de8";

export default node;
